define([
    "dojo/_base/declare",
    "csi/store/_base",
    "csi/toolbar/MultiSelectSwitchboard"
], function(declare,csiStore,MultiSelectSwitchboard) {

    return declare(MultiSelectSwitchboard, {
        idViewProperty: "printDesignColors",
        productStoreName: "printDesignColorsStore",
        disableButtonAction: true,
        refreshStoreOptions: true,

        /**
         * @override
         * return true if more than one print design color
         */
        canShowPlugin: function() {
            return !this._bEmptyStore;
        },

        /**
         * @override
         * refresh the store when the print design color nodes are known
         */
        postCreate: function() {
            var self = this;
            var view = this.getView();

            view.watch(this.productStoreName, function() {
                self.refreshStore(self.getViewPropertyValue());
            });

            this.inherited(arguments);
        },

        /**
         * @override
         * hide if printing
         */
        validatePlugin: function(/*Context*/ctx) {
            return !ctx.bPrint;
        },

        /**
         * @override
         * If no data, then store should be empty, and thus the switchboard should not be displayed
         */
        _getStoreOptions: function(url, r) {
            var store = this.getView().get(this.productStoreName);
            if (store) {
                var data = store.query().map(csiStore.nameObject);
                if (data.length > 1) {
                    return {
                        bSort: false,
                        data: data
                    };
                }
            }

            return null;
        }

    });
});